import React, { useState, useContext } from 'react';
import axios from 'axios';
import configData from '../../../config.json';
import Wheel from './Wheel';
import SelectSevenSection from './SelectSevenSection';
import ModalSevenConfirm from './TemplateGoals/ModalSevenConfirm';
import PickSevenV2 from '../../PortalV2/Steps/Goals/PickSevenV2';
import './OolaSevenSection.css';
import AppContext from '../../../Context/AppContext';

const OolaSevenSection = (props) => {
    const { checkUserSession, changeLoading } = useContext(AppContext);
    const currUser = checkUserSession();

    const AllProps = { ...props.AllState };
    if (!props.portalV2) {
        AllProps.CurrentF = 0;
    }

    const [showSevenConfirm, setShowSevenConfirm] = useState(false);
    const [confirmObj] = useState({
        ModalConfirmTitle: 'You have selected your Top 7. Ready to continue?',
        ModalConfirmDesc: 'Before jump to the next step text...',
    });

    function confirmGoals() {
        const picks = [...(props.AllState.SelectedGoalsSeven || [])]
            .filter(Boolean)
            .slice(0, 7);

        if (picks.length !== 7) {
            return;
        }

        const advanceToArrange = () => {
            setShowSevenConfirm(false);
            if (currUser.userStepId != 7 && props.handleChangeHeader) {
                props.handleChangeHeader(1);
            }
            try {
                sessionStorage.setItem(
                    'pv2-top7-picks',
                    JSON.stringify(picks)
                );
            } catch {
                /* ignore */
            }
            // Same as classic: Arrange only ranks SelectedGoalsSeven (the Top 7)
            props.changeData((prev) => ({
                ...prev,
                SelectedGoalsSeven: picks,
                CurrentStep2: (Number(prev.CurrentStep2) || 0) + 1,
                changeData: props.changeData,
            }));
            window.scrollTo(0, 0);
        };

        // Preview / unsaved GoalIds: skip API, keep the exact Top 7
        const missingIds = picks.some((p) => p.GoalId == null);
        if (props.portalV2 && missingIds) {
            advanceToArrange();
            return;
        }

        changeLoading(true);
        const PostObj = {
            Goals: picks.map((item) => ({
                GoalId: item.GoalId,
                SevenGoalOrder: 0,
            })),
        };

        const url = `${configData.SERVER_URL}Goals/SetSevenGoalsOrder`;

        axios
            .put(url, PostObj, {
                headers: {
                    Authorization: `Bearer ${currUser.token}`,
                },
            })
            .then(() => {
                changeLoading(false);
                advanceToArrange();
            })
            .catch((error) => {
                console.log(error);
                changeLoading(false);
                // V2: still advance with in-memory Top 7 so Arrange matches Pick
                if (props.portalV2) {
                    advanceToArrange();
                }
            });
    }

    if (typeof props.AllState.SelectedGoalsGroup === 'undefined') {
        const newObject = {};
        (props.AllState.SelectedGoals || []).forEach((x) => {
            if (!Object.prototype.hasOwnProperty.call(newObject, x.areaId)) {
                newObject[x.areaId] = {
                    Fs: AllProps.Fs[x.areaId],
                    selected: [],
                };
            }
            newObject[x.areaId].selected.push({
                areaId: x.areaId,
                date: x.date,
                recomendationIndex: x.recomendationIndex,
                text: x.text,
                selected: !!x.selected,
                Id: x.Id,
                GoalId: x.GoalId,
            });
        });

        props.AllState.SelectedGoalsGroup = newObject;
        props.changeData(props.AllState);
    }

    if (props.portalV2) {
        return (
            <div className="pv2-step2-glass">
                <PickSevenV2
                    AllState={props.AllState}
                    changeData={props.changeData}
                    confirmGoals={confirmGoals}
                    forceUpdate={props.forceUpdate}
                />
            </div>
        );
    }

    return (
        <section className="selectGoalTop7__container">
            <div className="selectGoalTop7__wrapper">
                <div className="selectGoalTop7__wrapperWheel">
                    <Wheel
                        AllState={props.AllState}
                        hideNav={false}
                        allColors
                    />
                </div>
                <div>
                    <SelectSevenSection
                        updateIndexStep2={props.updateIndexStep2}
                        forceUpdate={props.forceUpdate}
                        AllState={props.AllState}
                        changeData={props.changeData}
                        hideNav={false}
                        confirmGoals={confirmGoals}
                        setShowSevenConfirm={setShowSevenConfirm}
                    />
                    <div style={{ flex: 1, display: 'flex', width: '80%' }}>
                        <div
                            className="btnNextStep2"
                            aria-hidden="true"
                            style={{
                                color: '#D86B59',
                                marginLeft: 'auto',
                                pointerEvents:
                                    props.AllState.SelectedGoalsSeven.length ===
                                    7
                                        ? ''
                                        : 'none',
                            }}
                            onClick={() => confirmGoals()}
                        >
                            NEXT {'>'}
                        </div>
                    </div>
                </div>
            </div>
            <ModalSevenConfirm
                confirmGoals={confirmGoals}
                show={showSevenConfirm}
                setShowSevenConfirm={setShowSevenConfirm}
                ModalConfirmTitle={confirmObj.ModalConfirmTitle}
                ModalConfirmDesc={confirmObj.ModalConfirmDesc}
            />
        </section>
    );
};

export default OolaSevenSection;
